export default __webpack_public_path__ + "static/production1r-fd6b3e7c9d0e62930a3dc3eaf64ef97d.jpg";